const currencies = {
    EUR: 'EUR',
    GBP: 'GBP',
    NoCurrency: 'N/A',
    USD: 'USD',
} as const;

export default currencies;
